import {noop} from 'lodash'
import React, {useCallback, useContext, useState} from 'react'
import {CartItemBuilderAction, CartItemBuilderMode, StepOrder} from '../types'

type Props = {
  children: React.ReactNode
  onClose: () => void
  action: CartItemBuilderAction
  stepOrder: StepOrder
}

type AppearanceContextValue = {
  mode: CartItemBuilderMode
  action: CartItemBuilderAction
  stepOrder: StepOrder
  setInputMode: () => void
  setPreviewMode: () => void
  onClose: () => void
}

const AppearanceContext = React.createContext<AppearanceContextValue>({
  mode: 'input',
  action: 'creatingFirst',
  stepOrder: 'optionFirst',
  setInputMode: noop,
  setPreviewMode: noop,
  onClose: noop,
})

export const AppearanceProvider = ({children, onClose, action, stepOrder}: Props) => {
  const [mode, setMode] = useState<CartItemBuilderMode>('input')

  const setInputMode = useCallback(() => {
    setMode('input')
  }, [])

  const setPreviewMode = useCallback(() => {
    setMode('preview')
  }, [])

  const value = {
    mode,
    setInputMode,
    setPreviewMode,
    onClose,
    action,
    stepOrder,
  }

  return <AppearanceContext.Provider value={value}>{children}</AppearanceContext.Provider>
}

AppearanceProvider.useManager = () => {
  return useContext(AppearanceContext)
}
